import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
import RichTextStyles from '../RichText/RichText.styles';
const Container = styled(SectionWrapper) ``;
const Inner = styled.div `
  ${RichTextStyles.contentStyles};

  #CookieDeclarationUserStatusLabelConsentId {
    word-break: break-all;
  }
`;
export default {
    Container,
    Inner,
};
